import { css } from 'styled-components';
import colors from '../../style/colors';
import { deviceSizes } from '../../style';
import { actionColor, actionColorDark } from '../../style/theme-helpers';
import { TitleProps } from './index';

const sizes = {
  xxs: css`
    font-size: 0.625rem;
    line-height: 0.875rem;
  `,
  xs: css`
    font-size: 0.875rem;
    line-height: 1.375rem;
  `,
  sm: css`
    font-size: 1rem;
    line-height: 1.5rem;
  `,
  md: css`
    font-size: 1.25rem;
    line-height: 1.75rem;
  `,
  lg: css`
    font-size: 1.5rem;
    line-height: 2rem;
    @media (max-width: ${deviceSizes.sm}) {
      font-size: 1.3rem;
      line-height: 1.65rem;
    }
  `,
  xl: css`
    font-size: 2rem;
    line-height: 2.5rem;
    @media (max-width: ${deviceSizes.sm}) {
      font-size: 1.4rem;
      line-height: 1.75rem;
    }
  `,
  xxl: css`
    font-size: 2.5rem;
    line-height: 3rem;
    @media (max-width: ${deviceSizes.sm}) {
      font-size: 1.5rem;
      line-height: 1.8rem;
    }
  `,
  '2xxl': css`
    font-size: 3rem;
    line-height: 3.5rem;
    @media (max-width: ${deviceSizes.sm}) {
      font-size: 1.5rem;
      line-height: 1.5rem;
    }
  `,
};

const types = {
  p: '',
  span: css<TitleProps>`
    ${props => sizes[props.size || 'sm']};
  `,
  label: '',
  h1: css<TitleProps>`
    ${props => sizes[props.size || 'xxl']};
  `,
  h2: css<TitleProps>`
    ${(props: TitleProps) => sizes[props.size || 'xl']};
  `,
  h3: css<TitleProps>`
    ${props => sizes[props.size || 'lg']};
  `,
  h4: css<TitleProps>`
    ${props => sizes[props.size || 'md']};
  `,
  h5: css<TitleProps>`
    ${props => sizes[props.size || 'sm']};
  `,
  h6: css<TitleProps>`
    ${props => sizes[props.size || 'xs']};
  `,
};

const variants = {
  gray900: css`
    color: ${colors.gray900};
  `,
  gray300: css`
    color: ${colors.gray300};
  `,
  white: css`
    color: ${colors.white};
  `,
  gray800: css`
    color: ${colors.gray800};
  `,
  gray600: css`
    color: ${colors.gray600};
  `,
  gray400: css`
    color: ${colors.gray400};
  `,
  gray100: css`
    color: ${colors.gray100};
  `,
  negative: css`
    color: ${colors.negative};
  `,
  emerald: css`
    color: ${colors.emerald};
  `,
  darkEmerald: css`
    color: ${colors.darkEmerald};
  `,
  teal: css`
    color: ${colors.teal};
  `,
  darkTeal: css`
    color: ${colors.darkTeal};
  `,
  pumpkin: css`
    color: ${colors.pumpkin};
  `,
  darkPumpkin: css`
    color: ${colors.darkPumpkin};
  `,
  action: css`
    color: ${actionColor};
  `,
  actionDark: css`
    color: ${actionColorDark};
  `,
  highlight: css`
    color: ${colors.highlight};
  `,
  'negative-dark': css`
    color: ${colors.negativeDark};
  `,
  positive: css`
    color: ${colors.positive};
  `,
  'positive-dark': css`
    color: ${colors.positiveDark};
  `,
  inherit: css`
    color: inherit;
  `,
  attention: css`
    color: ${colors.attention};
  `,
  violet: css`
    color: ${colors.violet};
  `,
  darkViolet: css`
    color: ${colors.darkViolet};
  `,
  coral: css`
    color: ${colors.coral};
  `,
  bubbleGum: css`
    color: ${colors.bubbleGum};
  `,
  darkBubbleGum: css`
    color: ${colors.darkBubbleGum};
  `,
  'gradient-teal-to-violet': css`
    background: linear-gradient(to right, ${colors.teal}, ${colors.violet});
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  `,
  ametystPurple: css`
    color: ${colors.ametystPurple};
  `,
  raspberryPink: css`
    color: ${colors.raspberryPink};
  `,
  amberGlow: css`
    color: ${colors.amberGlow};
  `,
};

export { variants, types, sizes };
